import { Outlet } from "react-router";
import { Link } from "react-router-dom";
import ChanHeader from "../components/layout/ChanHeader";
import logo from "../assets/images/logo-white.svg";
import MenuItem from "../components/shared/MenuItem";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { SwapOutlined } from "@ant-design/icons";
import { BookOpenText, Users } from "lucide-react";
import { Tooltip } from "antd";
export default function ChanLayout() {
  const { user } = useContext(AuthContext);
  const menus = [
    {
      id: 1,
      isActive: true,
      access: [0, 1, 2, 3, 4, 5, 7, 8, 9],
      to: "/change/requests",
      name: "Requests",
      icon: <BookOpenText size={15} />,
    },
    {
      id: 1,
      isActive: true,
      access: [9],
      to: "/change/users",
      name: "Users",
      icon: <Users size={15} />,
    },
  ];
  return (
    <div className="h-screen bg-gray-100 font-toyota text-xxs">
      <div className="flex h-full">
        {/* Sidebar */}
        <div className="w-48 flex-shrink-0 bg-karimjee min-h-screen border-r text-white">
          <div className="border-b border-karimjee-dark flex items-center justify-center h-14 bg-karimjee">
            <img src={logo} alt="" width={110} />
          </div>
          <div className="p-2">
            <Tooltip title="Change Form">

              <Link
                to={"/autoline/dashboard"}
                className="flex items-center mb-2 px-2 py-1 hover:text-gray-200 border border-gray-500"
              >
                <SwapOutlined />
                <span className="mx-1"> Autoline Access Request</span>
              </Link>
            </Tooltip>
            <div className="flex flex-col">
              {menus?.map((menu: any, index: number) => {
                if (menu?.access?.includes(user?.accessLevel)) {
                  return (
                    <MenuItem
                      to={menu.to}
                      icon={menu.icon}
                      key={index}
                      name={menu.name}
                      className="hidden md:block"
                    />
                  );
                }
              })}
            </div>
          </div>
        </div>
        {/* Main Content */}
        <div className="flex-1 w-full overflow-hidden flex flex-col">
          <ChanHeader />
          <div className="flex-1 overflow-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
